<template>
  <div class="lottery-container">
    <p class="lottery-top">
      <van-icon class="goback" @click="goBack" name="arrow-left" size="24" />优惠券专区
    </p>
    <p class="lottery-title">
      每日限量盲盒
      <span @click="ruleShow = true">活动规则</span>
    </p>
    <div class="lottery-tool">
      <p class="blind-box">今日仅剩{{status.inventory}}个盲盒</p>
      <img class="lottery-machine" src="../../../static/images/machine.png" />
      <div v-if="status.isJoin == 1" class="lottery-btn">
        <p class="tip">
          <span></span>今日还有1次机会
        </p>
        <img
          @click="lotteryGet"
          v-if="status.isJoin == 1"
          src="../../../static/images/open_lottery.png"
        />
      </div>
      <div v-else class="lottery-btn">
        <p v-if="status.isJoin == 2" class="tip">
          <span></span>今日次数已用完 明日再来
        </p>
        <img
          v-if="status.isJoin == 2 || status.inventory == 0"
          src="../../../static/images/close_lottery.png"
        />
      </div>
    </div>
    <div class="my-prize">
      <p class="lottery-extract">
        盲盒领取说明
        <span @click="getPrize">已获奖品</span>
      </p>
      <div class="coupon-prize">
        <img src="../../../static/images/10.png" />
        <img src="../../../static/images/20.png" />
        <img src="../../../static/images/50.png" />
        <img src="../../../static/images/100.png" />
        <img src="../../../static/images/200.png" />
        <img src="../../../static/images/1000.png" />
      </div>
    </div>
    <div class="lottery-loading" v-if="isloading">
      <div class="lottery-box">
        <img src="../../../static/images/gift.gif" />
      </div>
    </div>
    <div class="lottery-loading" v-if="isWin">
      <div class="win-prize">
        <img class="prize-border" src="../../../static/images/coupon_border.png" />
        <img class="close" src="../../../static/images/lottery_shut.png" @click="isWin = false" />
        <p class="prize-title">恭喜开出以下奖品</p>
        <div class="getprize-content">
          <img :src="getLottery[0].img" />
          <div class="getprize-detail">
            <p class="getprize-name">{{getLottery[0].name}}</p>
            <p class="getprize-desc">{{getLottery[0].desc}}</p>
          </div>
        </div>
        <p class="use" @click="useCoupon(getLottery[0], getLottery[0].id)">去使用</p>
      </div>
    </div>
    <div class="lottery-loading" v-if="noPrize">
      <div class="no-prize">
        <img class="close" src="../../../static/images/lottery_close.png" @click="noPrize = false" />
        <p class="prize-title">未抽到奖品</p>
        <div class="noprize-content">
          <img src="../../../static/images/noprize.png" />
          <p>奖品已经被抽光了，下次早点来吧～</p>
        </div>
      </div>
    </div>
    <van-popup v-model="ruleShow" closeable class="rule-popup">
      <p class="rule-title">活动规则</p>
      <p>
        <span>1</span>优惠券盲盒每日限量抽取，先到先得；
      </p>
      <p>
        <span>2</span>每人每天仅有1次开盲盒机会；
      </p>
      <p>
        <span>3</span>每个盲盒中包含不同金额的优惠券，优惠券之间不可叠加使用，使用门槛详见各优惠券使用规则；
      </p>
      <p>
        <span>4</span>优惠券仅限在中公网校APP购买商品使用；
      </p>
      <p>
        <span>5</span>本活动最终解释权归中公网校所有。
      </p>
    </van-popup>
    <van-popup v-model="prizeShow" closeable class="prize-popup">
      <p class="rule-title">已获奖品</p>
      <div v-if="list && list.length">
        <div class="prize-list" v-for="(i, index) in list" :key="index">
          <div class="prize-content">
            <img :src="i.img" />
            <div class="prize-detail">
              <p class="prize-name">{{i.name}}</p>
              <p class="prize-desc">{{i.desc}}</p>
            </div>
            <p class="use-coupon" @click="useCoupon(i, i.id)">去使用</p>
          </div>
        </div>
      </div>
      <div v-else class="empty-list">
        <img src="../../../static/images/empty.png" />
        <p>暂未获得奖品，赶紧去抽奖吧～</p>
      </div>
    </van-popup>
    <div class="goods_wrapper" v-if="show">
      <div class="goods_box">
        <img class="closeList" @click="closeList" src="../../../static/images/guanbi.png" />
        <p class="goods_title">商品列表</p>
        <van-list
          v-model="loading"
          :finished="finished"
          finished-text="没有更多了"
          @load="onLoad"
          :immediate-check="false"
        >
          <van-cell v-for="(item, index) in goodsList" :key="index">
            <div class="goods_list" @click="goShop(item.url)">
              <div class="goods_content">
                <img :src="'//s.eoffcn.com/' + item.img" />
                <div class="goods_detail">
                  <p class="goods_name">{{item.name}}</p>
                  <p class="goods_price">
                    ¥
                    <span v-if="item.minPrice">{{item.minPrice / 100}} -</span>
                    {{item.maxPrice / 100}}
                  </p>
                </div>
              </div>
            </div>
          </van-cell>
        </van-list>
      </div>
    </div>
  </div>
</template>
<script>
import { Toast } from "vant";

export default {
  data() {
    return {
      ruleShow: false,
      prizeShow: false,
      isloading: false,
      isWin: false,
      noPrize: false,
      ticket: this.$route.query.ticket,
      ssoid:
        this.$route.query.ssoId ||
        (JSON.parse(localStorage.getItem("ticketObj"))
          ? JSON.parse(localStorage.getItem("ticketObj")).sso_id
          : false) ||
        localStorage.getItem("ssoId"),
      phone:
        this.$route.query.phone ||
        (JSON.parse(localStorage.getItem("ticketObj"))
          ? JSON.parse(localStorage.getItem("ticketObj")).phone
          : false) ||
        localStorage.getItem("phone"),
      sign: this.$route.query.sign,
      platform: this.$route.query.platform,
      version: this.$route.query.version,
      isAndroid:
        navigator.userAgent.indexOf("Android") > -1 ||
        navigator.userAgent.indexOf("Adr") > -1,
      isiOS: !!navigator.userAgent.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/),
      status: "",
      getLottery: [],
      list: [],
      page: 1,
      show: false,
      goodsList: [],
      loading: false,
      finished: false,
      couponId: "",
      total: 0,
      erpUrl: "",
      keUrl: ""
    };
  },
  mounted() {
    document.title = "\u200E";
    if (location.host == "xue.eoffcn.com") {
      this.erpUrl = "//erp.eoffcn.com";
      this.keUrl = "//ke.eoffcn.com";
    } else {
      this.erpUrl = "//erp.t.eoffcn.com";
      this.keUrl = "//ke.t.eoffcn.com";
    }

    setTimeout(() => {
      if (localStorage.getItem("phone") && localStorage.getItem("ssoId")) {
        this.ssoid = localStorage.getItem("ssoId");
        this.phone = localStorage.getItem("phone");
        console.log(54654654);
      }
      this.lotteryStatus();
    }, 200);
  },
  methods: {
    goBack() {
      if (this.isAndroid) {
        window.androidJS.goBack();
      } else if (this.isiOS) {
        let action = "goBack";
        window.webkit.messageHandlers.jsCallOCFunction.postMessage("goBack");
      }
    },
    lotteryStatus() {
      let that = this;
      $.ajax({
        url: this.erpUrl + "/api/lottery/status",
        type: "post",
        data: {
          user_id: this.ssoid,
          phone: this.phone
        },
        success: function(res) {
          if (res.code == 0) {
            that.status = res.data;
          }
        }
      });
    },
    lotteryGet() {
      console.log(this);
      let that = this;
      $.ajax({
        url: this.erpUrl + "/api/lottery/get",
        type: "post",
        data: {
          user_id: this.ssoid,
          phone: this.phone
        },
        success: function(res) {
          if (res.code == 0) {
            that.isloading = true;
            setTimeout(() => {
              that.isloading = false;
              that.getLottery = res.data.list;
              if (that.getLottery.length) {
                that.isWin = true;
              } else {
                that.noPrize = true;
              }
              that.lotteryStatus();
            }, 3000);
          } else {
            Toast(res.message);
          }
        }
      });
    },
    lotteryList() {
      let that = this;
      $.ajax({
        url: this.erpUrl + "/api/lottery/list",
        type: "post",
        data: {
          user_id: this.ssoid,
          phone: this.phone
        },
        success: function(res) {
          if (res.code == 0) {
            that.list = res.data.list;
          }
        }
      });
    },
    getPrize() {
      this.prizeShow = true;
      this.lotteryList();
    },
    closeList() {
      this.show = false;
      this.goodsList = [];
      this.page = 1;
    },
    useCoupon(i, id) {
      if (i.useAppIds.indexOf(1) > -1 || (!this.isAndroid && !this.isiOS)) {
        location.href = this.keUrl + "?sf=wxapp";
      } else {
        this.isWin = false;
        this.prizeShow = false;
        this.couponId = id;
        this.$api
          .GOODSLIST({
            "offcn-ticket": this.ticket,
            couponId: id,
            page: this.page++,
            page_size: 20
          })
          .then(res => {
            if (res.code == 0) {
              if (res.data.list.length == 1) {
                let params =
                  "?phone=" +
                  this.phone +
                  "&sign=" +
                  this.sign +
                  "&platform=" +
                  this.platform +
                  "&version=" +
                  this.version +
                  "&sf=wxapp";
                // location.href = res.data.list[0].url + params
                location.href = this.keUrl + params;
              } else {
                this.show = true;
                this.loading = false;
                this.goodsList = [...this.goodsList, ...res.data.list];
                if (this.page == 2) {
                  this.total = res.data.total;
                }
              }
            } else if (res.code == 2) {
              this.$router.push({ path: "/" });
            }
          });
      }
    },
    onLoad() {
      if (this.total === this.goodsList.length) {
        this.finished = true;
      } else {
        this.useCoupon("", this.couponId);
      }
    },
    goShop(url) {
      location.href =
        url +
        "?phone=" +
        this.phone +
        "&sign=" +
        this.sign +
        "&platform=" +
        this.platform +
        "&version=" +
        this.version;
    }
  }
};
</script>

<style lang="less" scoped>
.lottery-container {
  height: 100%;
  background: url(./static/images/lottery_banner.png) no-repeat;
  background-size: contain;
  p {
    margin: 0;
  }
  .lottery-top {
    text-align: center;
    font-size: 36px;
    font-weight: bold;
    color: #ffffff;
    padding-top: 50px;
    .goback {
      position: absolute;
      left: 30px;
    }
  }
  .lottery-title {
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-size: 40px;
    font-weight: bold;
    color: #ffffff;
    margin: 50px 30px 0;
    span {
      width: 120px;
      height: 40px;
      text-align: center;
      line-height: 40px;
      color: #f7312c;
      font-size: 22px;
      font-weight: normal;
      background: linear-gradient(0deg, #ffd1d2 0%, #fffcf2 100%);
      border-radius: 20px;
    }
  }
  .lottery-tool {
    position: relative;
    .blind-box {
      position: absolute;
      top: 100px;
      left: 50%;
      transform: translate(-50%);
      color: #ffffff;
      font-size: 24px;
    }
    .lottery-machine {
      width: 100%;
    }
    .lottery-btn {
      position: absolute;
      left: 204px;
      bottom: 120px;
      img {
        width: 350px;
      }
      p {
        position: absolute;
      }
    }
    .tip {
      position: absolute;
      top: -65px;
      left: 50%;
      transform: translate(-50%);
      height: 40px;
      line-height: 40px;
      box-shadow: 0px 5px 10px 0px rgba(251, 107, 98, 0.18);
      color: #e60012;
      white-space: nowrap;
      border-radius: 20px;
      background: #ffffff;
      padding: 0 24px;
      span {
        position: absolute;
        top: 40px;
        left: 50%;
        transform: translate(-50%);
        width: 0;
        height: 0;
        border: 12px solid transparent;
        border-top-color: #ffffff;
      }
    }
  }
  .my-prize {
    padding: 0 30px;
    .lottery-extract {
      display: flex;
      justify-content: space-between;
      font-size: 30px;
      font-weight: bold;
      margin-top: 60px;
      span {
        width: 120px;
        height: 40px;
        text-align: center;
        line-height: 40px;
        font-size: 22px;
        font-weight: normal;
        color: #999999;
        border: 1px solid #999999;
        border-radius: 20px;
      }
    }
    .coupon-prize {
      display: flex;
      flex-wrap: wrap;
      justify-content: space-between;
      margin-top: 24px;
      img {
        width: 220px;
        height: 140px;
        margin-bottom: 20px;
      }
    }
  }
  .lottery-loading {
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    background: rgba(0, 0, 0, 0.5);
    .lottery-box {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      img {
        width: 294px;
      }
    }
    .win-prize {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      width: 520px;
      height: 435px;
      border-radius: 20px;
      background: url(./static/images/coupon_bg.png) #ffffff no-repeat;
      background-size: contain;
      .prize-border {
        position: absolute;
        width: 562px;
        left: -10px;
        top: -14px;
      }
      .close {
        position: absolute;
        top: 30px;
        right: 30px;
        width: 25px;
      }
      .prize-title {
        text-align: center;
        font-size: 36px;
        font-weight: bold;
        color: #ffffff;
        margin-top: 50px;
      }
      .getprize-content {
        display: flex;
        align-items: center;
        width: 420px;
        border-radius: 10px;
        background: #ffffff;
        margin: 0 auto;
        margin-top: 40px;
        padding: 10px;
        img {
          width: 150px;
        }
        .getprize-detail {
          margin-left: 10px;
          .getprize-name {
            width: 240px;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
          }
          .getprize-desc {
            color: #999999;
            overflow: hidden;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 2;
          }
        }
      }
      .use {
        width: 400px;
        height: 80px;
        text-align: center;
        line-height: 80px;
        font-size: 30px;
        color: #ffffff;
        border-radius: 40px;
        background: linear-gradient(45deg, #e72b30 0%, #fd6455 100%);
        margin: 0 auto;
        margin-top: 60px;
      }
    }
    .no-prize {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      width: 520px;
      height: 435px;
      border-radius: 20px;
      background: #ffffff;
      .prize-title {
        text-align: center;
        font-size: 36px;
        font-weight: bold;
        margin-top: 60px;
      }
      .close {
        position: absolute;
        top: 30px;
        right: 30px;
        width: 25px;
      }
      .noprize-content {
        text-align: center;
        font-size: 26px;
        color: #999999;
        img {
          width: 234px;
          margin-top: 96px;
          margin-left: 40px;
        }
      }
    }
  }
  .rule-popup {
    width: 520px;
    height: 600px;
    line-height: 40px;
    font-size: 24px;
    color: #666666;
    border-radius: 20px;
    padding: 0 30px;
    .rule-title {
      text-align: center;
      color: #333333;
      font-size: 36px;
      font-weight: bold;
      margin: 60px 0 38px;
    }
    p span {
      display: inline-block;
      width: 28px;
      height: 28px;
      text-align: center;
      line-height: 28px;
      color: #ffffff;
      background: #ff8080;
      border-radius: 50%;
      margin-right: 12px;
    }
  }
  .prize-popup {
    width: 670px;
    max-height: 900px;
    border-radius: 20px;
    padding-bottom: 40px;
    .rule-title {
      text-align: center;
      font-size: 36px;
      font-weight: bold;
      margin-top: 60px;
    }
    .prize-list {
      padding: 0 30px;
      margin-top: 40px;
      .prize-content {
        display: flex;
        justify-content: space-between;
        align-items: center;
        background: #f5f5f5;
        border-radius: 20px;
        padding: 10px 20px;
        img {
          width: 150px;
          height: 100px;
        }
        .prize-detail {
          margin-left: 20px;
          .prize-name {
            width: 278px;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
          }
          .prize-desc {
            width: 262px;
            color: #999999;
            overflow: hidden;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 2;
            margin-top: 18px;
          }
        }
        .use-coupon {
          width: 120px;
          height: 54px;
          text-align: center;
          line-height: 54px;
          color: #ffffff;
          border-radius: 28px;
          background: linear-gradient(45deg, #fd6455 0%, #e72b30 100%);
        }
      }
    }
    .empty-list {
      text-align: center;
      img {
        width: 218px;
        margin-top: 156px;
      }
      p {
        color: #999999;
        font-size: 30px;
        margin-top: 40px;
      }
    }
  }
  .goods_wrapper {
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    background: rgba(0, 0, 0, 0.5);
    .goods_box {
      position: fixed;
      width: 100%;
      bottom: 0;
      height: 854px;
      overflow-y: scroll;
      border-radius: 30px 30px 0px 0px;
      background-color: #ffffff;
    }
    .goods_title {
      position: absolute;
      top: 0;
      left: 50%;
      transform: translate(-50%);
      font-size: 28px;
      font-weight: bold;
      margin-top: 38px;
    }
    .closeList {
      position: absolute;
      top: 38px;
      right: 30px;
      width: 32px;
      height: 32px;
    }
    .van-list {
      margin-top: 60px;
    }
    .goods_list {
      height: calc(100% - 148px);
      margin: 0 30px;
      overflow-y: scroll;
      .goods_content {
        display: flex;
        align-items: center;
        border-bottom: 1px solid #e5e5e5;
        padding: 30px 0;
        img {
          width: 186px;
          height: 106px;
          border-radius: 20px;
        }
        .goods_detail {
          margin-left: 22px;
          .goods_name {
            font-size: 28px;
            font-weight: bold;
            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 2;
            overflow: hidden;
            text-overflow: ellipsis;
          }
          .goods_price {
            font-size: 30px;
            color: #e60012;
            margin-top: 20px;
          }
        }
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/lottery/index.vue